import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useSelector, useDispatch } from 'react-redux';

import LoginActionModalContainer from './LoginActionModalContainer';
import { openLoginModal } from 'store/slice/HeaderSlice';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  width: { lg: '50%', xs: '90%' },
  height: { lg: '70%', xs: '70%' },
  borderRadius: 3,
  //overflow:'scroll',
  p: 1,
  backgroundColor:'secondary.lighter',
};

export default function LoginActionModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);;
  const {loginModalOpen} = useSelector((state)=>state.headerslice.login);
  const {isLoggedIn} = useSelector((state)=>state.headerslice);

  useEffect(()=>{
  },[loginModalOpen])

  useEffect(()=>{
    handleModalClose();
  },[isLoggedIn])

  const handleModalClose=()=>{
    handleClose();
    dispatch(openLoginModal(false));
  }
  return (
    <Modal
       open={loginModalOpen===undefined?false:loginModalOpen}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} >

        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h5"  >
              Login
            </Typography>
          </Grid>
          <Grid item>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={() => handleModalClose()} />
          </Grid>
        </Grid>
        <Grid item>
          <Divider />
          <Box height="20px"></Box>
        </Grid>
        <Grid item>
            < LoginActionModalContainer/>
        </Grid>

      </Box>
    </Modal>
  );
}